module.exports = __webpack_public_path__ + "img/logo-gia@2x.4668cdc.png";